// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2021 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { TenantId } from "./types";

const enabledTenants = process.env.REACT_APP_ENABLED_TENANTS?.split(
  ","
).map((id) => id.trim());

/**
 * Tenants have to be explicitly enabled per environment; this function
 * checks against that configuration for a given tenant.
 */
export function isTenantEnabled(id: TenantId): boolean {
  return Array.isArray(enabledTenants) && enabledTenants.includes(id);
}
